<ng-container *ngIf="formGroup" [formGroup]="formGroup">
    <div class="row pb-2" *ngIf="formGroup.get('firstNotifiedDate')">
        <label class="col-3 mt-2 text-end mogo-bold" for="pickup-close-input">First Notified Date:</label>

        <app-custom-date-range-picker class="col-9"
            formControlName="firstNotifiedDate"
            placeholder="Select date">
        </app-custom-date-range-picker>
    </div>

    <div class="row pb-2" *ngIf="formGroup.get('documentsReceivedDate')">
      <label class="col-3 mt-2 text-end mogo-bold" for="pickup-close-input">Document Received Date:</label>

      <app-custom-date-range-picker formControlName="documentsReceivedDate" placeholder="Select date" class="col-9">
      </app-custom-date-range-picker>
    </div>

    <div class="row pb-2" *ngIf="formGroup.get('documentsReceivedDate')">
      <label class="col-3 mt-2 text-end mogo-bold" for="pickup-close-input">Documents Received Late:</label>
      <div class="col-1 text-start mt-2">
        <input
        type="checkbox"
        formControlName="documentsReceivedLate" />
      </div>

    </div>

    <div class="row pb-2">
      <label class="col-3 mt-2 text-end mogo-bold" for="pickup-close-input">Has Dangerous Goods:</label>
      <div class="col-1 text-start mt-2">
        <input
          class=""
              type="checkbox"
              formControlName="isHazmat" />
      </div>
    </div>

    <div class="row" *ngIf="getHazmatCodeIsRequired()">
      <label class="col-3 mt-2 text-end mogo-bold" for="pickup-close-input">UN Hazard Code:</label>
      <div class="col-9 ">

        <ng-select
            formControlName="hazmatCode"
            [items]="availableHazardCodes"
            bindLabel="alias"
            placeholder="Select UN Hazard Code">
        </ng-select>
      </div>

    </div>

</ng-container>
